import React, { useContext, useEffect } from 'react';
import './styles.css';
import { Button } from '@material-ui/core';
import { withRoomContext } from '../../RoomContext';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GradientButton from '../customMui/newButton/newButton';
import deviceInfo from '../../deviceInfo';
import ControllerContext from '../../RoomControllerSocketContext';
import { useIntl } from 'react-intl';

function WaitingRoomAndEndMeetPage(props)
{

	const {
		room, roomClient
	} = props;
	const device = deviceInfo();

	const { pluginSocket } = useContext(ControllerContext);

	const urlParser = new URL(window.location);

	const parameters = urlParser.searchParams;
	const intl = useIntl();

	const leave=parameters.get('leave');
	const MeetingName = roomClient?._roomTemplate?.meetingDetails?.meetingName;

	// if (parameters.get('leave') !== undefined && parameters.get('leave') !== null)
	// {
	// 	leave=parameters.get('leave');
	// }

	function desktopNavigate()
	{
		try
		{
			if (window.location.host.includes('localhost'))
			{
				window.location = `${window.location.origin}/desktop_room`;
			}
			else
			{
				window.location = `https://${window.location.hostname}/desktop_room`;
			}
		}
		catch (error)
		{
			console.log('error in redirect to dashboard event==', error);
		}

	}

	useEffect(() =>
	{
		pluginSocket?.on('redirectToDashboard', () =>
		{
			if (device.platform === 'desktop' && device.name === 'electron')
			{
				desktopNavigate();
			}
		});

		return () =>
		{
			pluginSocket?.off('redirectToDashboard');
		};
	}, [ pluginSocket ]);

	const handleNavigate = () =>
	{
		if (device.platform === 'desktop' && device.name === 'electron')
		{
			try
			{
				pluginSocket?.emit('redirectToDashboard');
				desktopNavigate();
			}
			catch (error)
			{
				console.log('error in redirect to dashboard event', error);
			}
		}
		else
		{
			// if (roomClient?._roomTemplate?.data?.exitUrl)
			// {
			// 	window.location.href = roomClient?._roomTemplate.data.exitUrl;
			// }
			// else
			// {
			window.location.href = roomClient?._roomTemplate?.data?.exitUrlStatus ? roomClient?._roomTemplate?.data?.exitUrl : import.meta.env.VITE_config;
			// }
		}
	};

	useEffect(() =>
	{
		if (leave || !(room?.inLobby || room?.locked || room?.sessionExp))
		{
			setTimeout(() =>
			{
				if (device.platform === 'desktop' && device.name === 'electron')
				{
					handleNavigate();
				}
			}, 5000);
		}
	}, [ leave, room?.inLobby, room?.locked, room?.sessionExp ]);

	return (
		<div className='flexCol endMeetingPage pdngMD'>
			<div className='flexRow pdngLG'>
				<img src='/images/inmeet2.png' alt='logo' className='logo ' />
			</div>
			<div className='flexCol endMeetingBody jCntr aCntr'>
				{
					(room?.inLobby || room?.locked || room?.sessionExp) ?
						<>
							<img src='/images/waitingroom.png' alt='waitingroom' />
							<span className='wTxt mHdng'>{MeetingName}</span>
							<span className='wTxt pdngVMD'><b>{intl.formatMessage({ id: 'Host', defaultMessage: 'Host>>>:' })}</b> {roomClient?._roomTemplate?.meetingDetails?.hostName}</span>
							{room?.locked && <span className='wTxt textCntr '>
								 {intl.formatMessage({ id: 'ThanksForWaitingWeWillStartTheMeeting', defaultMessage: 'Thanks for Waiting. we will let you know' })} <br/> {intl.formatMessage({ id: 'whenHostUnlockTheRoom', defaultMessage: 'when host unlock the room:' })}
							</span>}
							{room?.sessionExp && <span className='wTxt textCntr '>
								 Thanks for join the meeting the session has completed.
							</span>}
							{room?.inLobby &&
								<span className='wTxt textCntr'>{intl.formatMessage({ id: 'ThanksForWaitingWeWillStartTheMeeting', defaultMessage: 'Thanks for Waiting. we will let you know' })} <br />{intl.formatMessage({ id: 'WhenTheHostJoins.', defaultMessage: 'when host is ready.' })}</span>}
							<div className='flexRow pdngVMD jCntr aCntr'>
								<Button
									color='secondary'
									variant='outlined'
									size='large'
									disableElevation
									style={{ borderRadius: '10px' }}
									onClick={handleNavigate}
								>
									{intl.formatMessage({ id: 'Cancel', defaultMessage: 'Cancel:' })}
								</Button>
							</div>
						</>
						:
						<>
							<div className='flexRow jCntr aCntr pdngSM '>
								<img
									src='/images/endMeeting.png'
									alt='endMeeting'
								/>
							</div>
							{leave?
								<span className='wTxt '>
									{intl.formatMessage({ id: 'ThanksForChoosingInMeetYouLeft', defaultMessage: 'Thanks for Choosing InMeet.You left:' })}
								</span>:<span className='wTxt '>
									{intl.formatMessage({ id: 'ThanksForChoosingInMeetTheHostHasEnded', defaultMessage: 'Thanks for Choosing InMeet. The Host has ended' })}
								</span>
							}
							<span className='wTxt'>{intl.formatMessage({ id: 'theMeeting', defaultMessage: 'the meeting:' })}</span>
							<div className='flexRow pdngVSM jCntr aCntr'>
								<GradientButton
									color='primary'
									variant='contained'
									size='large'
									disableElevation
									style={{ borderRadius: '10px' }}
									onClick={handleNavigate}
								>
									{intl.formatMessage({ id: 'Done', defaultMessage: 'Done' })}
								</GradientButton>
							</div>

						</>
				}
			</div>
			<div className='flexCol alignCntr endMeetingFooter'>
				<small className='footerTxt'>
					© {intl.formatMessage({ id: '2022InstaVCIncAllRightsReservedIAgreeToThe', defaultMessage: '2022 InstaVC Inc. All Rights Reserved - I agree to the' })}
					{' '}
					<a
						className='termLinks'
						target='_blank'
						href='https://www.instavc.com/terms-and-conditions/'
						rel='noreferrer'
					>
						{intl.formatMessage({ id: 'TermsConditions', defaultMessage: 'Terms & Conditions' })}
					</a>
					{' '}
					{intl.formatMessage({ id: 'and', defaultMessage: 'and' })}
					{' '}
					<a
						target='_blank'
						className='termLinks'
						href='https://www.instavc.com/privacy-policy/'
						rel='noreferrer'
					>
						{intl.formatMessage({ id: 'PrivacyPolicy', defaultMessage: 'Privacy Policy.' })}
					</a>
				</small>
			</div>
		</div>
	);
}

WaitingRoomAndEndMeetPage.propTypes =
{
	room       : PropTypes.object,
	roomClient : PropTypes.object.isRequired

};

const mapDispatchToProps = () =>
	({

	});

const mapStateToProps = (state) =>
{

	return ({
		room : state.room
	});
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room === next.room
			);
		}
	}
)((WaitingRoomAndEndMeetPage)));